import { clsx } from 'clsx';
import { memo } from 'react';
import type { AriaAttributes, AriaRole, ReactNode } from 'react';
import styles from './Table.module.scss';

export interface TableDataProps extends AriaAttributes {
    children: ReactNode;
    /**
     * Aria role for this component.
     */
    role?: AriaRole;
    /**
     * Corresponds to colspan HTML Attribute for tables
     */
    colSpan?: number;
    /**
     * On click handler
     */
    onClick?(): void;
    /**
     * The width of the cell
     */
    width?: string;
    /**
     * The vertical align of cell
     */
    verticalAlign?: 'baseline' | 'middle' | 'top' | 'bottom';
}

const TableCell = ({
    children,
    role,
    onClick,
    colSpan,
    width,
    verticalAlign,
    ...ariaProps
}: TableDataProps) => {
    return (
        <td
            {...ariaProps}
            className={clsx(styles.tableData, {
                [styles.interactable]: !!onClick,
                [styles[`${verticalAlign}VerticalAlign`]]: !!verticalAlign,
            })}
            style={{ width }}
            tabIndex={onClick ? 0 : undefined}
            onClick={onClick}
            role={role}
            colSpan={colSpan}
            onKeyDown={e => {
                if ([' ', 'Enter'].includes(e.key)) {
                    onClick?.();
                }
            }}
        >
            {children}
        </td>
    );
};

export default memo(TableCell);
